/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages
          (function($){
              $(".navbar-main-menu>li").each(function(){
                  sub_child = $(this).find('.dropdown-menu').children().length;
                  if (sub_child>0) {
                      $(this).find('> a').append('<span class="expand"><i class="icon-chevron-arrow-down"></i></span>');
                  }
              });

              $(document).ready(function(){
                  if($(window).innerWidth() >= 767) {
                    //  $(".content-with-sidebar-left-top").sticky();
                  }
              });

              $(".search-toggle-btn").click(function() {
                  $(this).toggleClass("is-triggered");
                  $(this).next(".dropdown-search").toggleClass("is-triggered");
              });


              $(".navbar-main-menu>li>.dropdown-menu>li").each(function(){
                  sub_child = $(this).find('.dropdown-menu').children().length;
                  if (sub_child>0) {
                      $(this).find('> a').append('<span class="expand"><i class="icon-chevron-arrow-down"></i></span>');
                  }
              });

              $('.navbar-main-menu>li>a>.expand').click(function (e) {
                  e.preventDefault();
                  $('.navbar-main-menu>li>a').find('.dropdown-menu').not($(this).parent('a').parent('li').find('.dropdown-menu')).slideUp(100);
                  $(this).parent('a').next('.dropdown-menu').slideToggle(100);
              });

              $('.navbar-main-menu>li>.dropdown-menu>li>a>.expand').click(function (e) {
                  e.preventDefault();
                  $('.navbar-main-menu li .dropdown-menu li').find('.dropdown-menu').not($(this).parent('.dropdown-menu li a').parent('.dropdown-menu li').find('.dropdown-menu')).slideUp(100);
                  $(this).parent('.dropdown-menu li a').parent('.dropdown-menu>li').find('.dropdown-menu').slideToggle(100);
              });


              $( ".section-archive-exams .content-main .open-content-more" ).click(function() {
                  $(".section-archive-exams .content-main .drop-content").slideDown();
                  $(".section-archive-exams .content-main .open-content-more").hide();
                  $(".section-archive-exams .content-main .open-content-less").show();
              });

              $( ".section-archive-exams .content-main .open-content-less" ).click(function() {
                  $(".section-archive-exams .content-main .drop-content").slideUp();

                   $(".section-archive-exams .content-main .open-content-less").hide();
                   $(".section-archive-exams .content-main .open-content-more").show();

              });

              $('.card-body .collapse').on('shown.bs.collapse', function(e) {
                  var $panel = $(this).closest('.card');
                  $('html,body').animate({
                      scrollTop: $panel.offset().top - 143
                  }, 500);
              });


              var checkbox = $('.gform_body ul li:not(.checkbox_not)').find('input[type=checkbox]');
              var month = new Array();
              month[0] = "January";
              month[1] = "February";
              month[2] = "March";
              month[3] = "April";
              month[4] = "May";
              month[5] = "June";
              month[6] = "July";
              month[7] = "August";
              month[8] = "September";
              month[9] = "October";
              month[10] = "November";
              month[11] = "December";

              var d = new Date();

              var month = month[d.getMonth()];
              var day = d.getDate();

              var output = month + ' ' + day + ', ' + d.getFullYear();

              $('.certifications-form .gform_body ul li input[type=checkbox]').on('click change',function() {
                  if ($(this).is(':checked')) {
                      $(this).closest('li').parent().closest('li').next().find('input[type=text]').attr('value', output);
                      $(this).closest('li').parent().closest('li').next().find('input[type=text]').val(output);
                      $(this).closest('li').parent().closest('li').next().find('input[type=text]').addClass('noClick');
                  }
                  else {
                      $(this).closest('li').parent().closest('li').next().find('input[type=text]').attr('value', '');
                      $(this).closest('li').parent().closest('li').next().find('input[type=text]').addClass('noClick');
                  }
              });

              $('.certifications-form #choice_1_1_1').click(function () {
                  if ($(this).is(':checked')) {
                      checkbox.prop("checked", true).trigger("change");
                      checkbox.addClass('noClick');
                      $(this).removeClass('noClick');
                      checkbox.closest('li').parent().closest('li').next().find('input[type=text]').attr('value', output);
                      checkbox.closest('li').parent().closest('li').next().find('input[type=text]').val(output);
                  }
                  else {
                      checkbox.prop("checked", false).trigger("change");
                      checkbox.removeClass('noClick');
                      checkbox.closest('li').parent().closest('li').next().find('input[type=text]').attr('value', '');
                  }
              });


          })(jQuery);

          $(document).ready(function(){
              $(".owl-home-carousel").owlCarousel({
                  autoplay:true,
                  autoplaySpeed: 1500,
                  autoplayTimeout: 7000,
                  autoplayHoverPause:false,
                  loop:true,
                  margin:10,
                  nav:false,
                  dots:true,
                  items:1,
              });

              $('.owl-sponsors-carousel').owlCarousel({
                  loop:true,
                  margin:10,
                  items:5,
                  nav:true,
                  dots:false,
                  responsive:{
                      0:{
                          items:1
                      },
                      767:{
                          items:3
                      },
                      1025:{
                          items:5
                      }
                  }
              });

          });

      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
